import { render } from "./HszdAudio.vue?vue&type=template&id=40e4bca0&scoped=true"
import script from "./HszdAudio.vue?vue&type=script&lang=js"
export * from "./HszdAudio.vue?vue&type=script&lang=js"

import "./HszdAudio.vue?vue&type=style&index=0&id=40e4bca0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e4bca0"]])

export default __exports__